module.exports = __webpack_public_path__ + "img/heartsArrows-1.0bffae0.png";